import { DateTime } from 'luxon';

/**
 * Ensures a date is parsed to the given timezone
 *
 * @param ISODate - A date string in ISO format
 * @param zone - The ISODate timezone string. Defaults to UTC. Use this zone if no offset is specified in the input string itself. Will also convert the time to this zone.
 *
 * @returns luxon DateTime object
 */
export const resolveDateToTimezone = (ISODate: string, zone?: string): DateTime =>
  DateTime.fromISO(ISODate, { zone: zone ?? 'UTC' });

/**
 * Ensures a date is converted to Melbourne timezone. By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations.
 *
 * @param ISODate - A date string in ISO format
 * @param zone - The ISODate timezone string. Defaults to UTC. Use this zone if no offset is specified in the input string itself. Will also convert the time to this zone.
 *
 * @returns luxon DateTime object
 */
export const resolveISODateToAEDTAEST = (ISODate: string, zone?: string): DateTime =>
  resolveDateToTimezone(ISODate, zone).setZone('Australia/Melbourne');
